export class ServiceCharacter {
    name: string;
    id: number;
    code: string;
}